import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'Actions/router';
import qs from 'qs';
import * as iconStyles from '../../styles/icons.css';
import * as styles from './tableHeader.css';

// This doesn't use a stateful but ag-grid requires it :(
// eslint-disable-next-line react/prefer-stateless-function
class TableHeader extends Component {
  render() {
    const { displayName, column = {}, onClick } = this.props;
    return (
      <div className={styles.tableHeader}>
        <div className={styles.name}>{displayName}</div>
        {!column.pinned &&
          <button className={styles.removeBtn} onClick={onClick}>
            <i className={iconStyles.iconClose} />
          </button>}
      </div>
    );
  }
}

TableHeader.propTypes = {
  displayName: PropTypes.string.isRequired,
  column: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, { ...props, column: { colId } }) => {
  const { store } = props;
  const { getState } = store;
  // If we're removing our states, reset app, but retain indicators.
  if (getState().router && 'string' === typeof getState().router.geos) {
    return {
      onClick: () => {
        const params = {
          stage: 2,
        };
        const {
          indicators,
        } = getState().router;
        if (indicators) {
          params.indicators = indicators.join(',');
        }
        window.location.href = `/statedata/custom/?${qs.stringify(params)}`; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
      },
    };
  }

  return {
    onClick: () => dispatch(push({ geos: colId })),
  };
};

const Connnected = connect(undefined, mapDispatchToProps)(TableHeader);

export default (props) =>
  <Connnected {...props} store={props.context.store()} />; // eslint-disable-line react/prop-types

export {
  TableHeader,
  mapDispatchToProps,
};



// WEBPACK FOOTER //
// ./app/components/tableHeader/index.js